<app-layout>
  <app-voltar route="listagem/engates" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>Engate</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
      <app-subtitulo>
        Informe o número do agendamento ou a placa no pátio e confirme os dados
        para registrar o engate
      </app-subtitulo>
      <div class="formList">
        <app-input
          type="number"
          label="N° do Agendamento"
          placeholder="Digite aqui"
          name="FK_AGND"
          formControlName="FK_AGND"
          (blurEvent)="onAgendamentoChange()"></app-input>
        <app-input
          type="text"
          label="Placa da carreta para pesquisar"
          placeholder="Digite aqui"
          name="TX_PLCA_DSGT"
          formControlName="TX_PLCA_DSGT"
          mask="AAA-0A00"
          class="placaField"
          (blurEvent)="onPlacaChange()"></app-input>
        <app-input
          type="disabled"
          label="Motorista"
          name="NM_MTRT_DSGT"
          formControlName="NM_MTRT_DSGT"
          placeholder="Digite aqui"
          [disabled]="true"></app-input>
        <app-input
          type="disabled"
          label="Placa(s) da(s) carreta(s) desengatada(s)"
          name="CRRT_DSGT"
          formControlName="CRRT_DSGT"
          placeholder="Aguardando"
          [disabled]="true"></app-input>
        <!-- <div class="checkbox">
          <label for="FL_MTRT_EMPR">É motorista de empresa?</label>
          <input
            type="checkbox"
            id="FL_MTRT_EMPR"
            name="FL_MTRT_EMPR"
            formControlName="FL_MTRT_EMPR" />
        </div> -->
      </div>
      <app-subtitulo>Informe as placas para entrada do engate</app-subtitulo>
      <div class="formList">
        <app-input
          type="text"
          label="N° Gate de Entrada"
          name="FK_GATE_ENTR"
          formControlName="FK_GATE_ENTR"
          placeholder="Digite aqui"
          (blurEvent)="onGetGateEntrada()"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Motorista"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          placeholder="Aguardando"
          [requiredInput]="true"></app-input>
        <app-input
          type="email"
          label="E-mail do Motorista"
          name="TX_MAIL"
          formControlName="TX_MAIL"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="text"
          label="CPF"
          name="TX_CPF"
          formControlName="TX_CPF"
          mask="000.000.000-00"
          placeholder="Digite aqui"
          [requiredInput]="true"></app-input>
        <app-input
          type="text"
          label="Telefone"
          name="TX_TELE"
          formControlName="TX_TELE"
          mask="(00) 0000-0000||(00) 00000-0000"
          placeholder="Digite aqui"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          mask="AAA-0A00"
          placeholder="Digite Aqui"
          (blurEvent)="onGetEntradaByCavalo()"
          [requiredInput]="true"
          class="placaField"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Carreta 1"
          name="TX_PLCA_CRRT1"
          formControlName="TX_PLCA_CRRT1"
          mask="AAA-0A00"
          placeholder="Aguardando"
          class="placaField"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Carreta 2"
          name="TX_PLCA_CRRT2"
          formControlName="TX_PLCA_CRRT2"
          mask="AAA-0A00"
          placeholder="Aguardando"
          class="placaField"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Carreta 3"
          name="TX_PLCA_CRRT3"
          formControlName="TX_PLCA_CRRT3"
          mask="AAA-0A00"
          placeholder="Aguardando"
          class="placaField"
          [disabled]="true"></app-input>
        <app-input
          type="textarea"
          label="Observação"
          name="TX_OBSV_ENGT_DSGT"
          formControlName="TX_OBSV_ENGT_DSGT"
          placeholder="Digite aqui"
          [requiredInput]="true"
          [disabled]="true"></app-input>
        <span></span>
        <app-botao
          *ngIf="!permissionToken && !isViewing"
          class="autorization"
          text="Autorizar Engate"
          icon="assets/icons/engate.svg"
          (click)="openAcessoRestrito()"></app-botao>
      </div>
      <app-botao
        *ngIf="!isViewing"
        type="cadastro"
        class="botao-cadastro"
        [text]="!isEditing ? 'Registrar Engate' : 'Editar Engate'"
        (click)="saveEngate()"
        [disabled]="!form.valid || !permissionToken"></app-botao>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
